const lang = {
  contact: 'Contact',
  born: 'Born',
  bornIn: 'in',
  experience: 'Experience',
  education: 'Education',
  skills: 'Skills',
  about: 'About me'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/en.js